import React, {useState, useEffect} from 'react';
import Link from '../utils/link';
import parse from 'html-react-parser';
import Arrow from '../assets/images/dropdown.svg';
import {TextInput, TextAreaInput, Checkbox, DropdownInput} from '../utils/form-inputs';

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&")
}

const RegisterYourInterest = ({title, content, extraClass}) => {

  const [project, setProject] = useState(title)
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [phone, setPhone] = useState("")
  const [howYouHear, setHowYouHear] = useState("")
  const [news, setNews] = useState("")
  const [result, setResult] = useState(false)

  const [utmParams, setUtmParams] = useState({
    utm_source: "",
    utm_medium: "",
    utm_campaign: "",
    utm_term: "",
    utm_content: "",
  });

  // Load UTM parameters from sessionStorage when the component mounts
  useEffect(() => {
    if (typeof window !== "undefined") {
      const storedParams = sessionStorage.getItem("utmParams");
      if (storedParams) {
        setUtmParams(JSON.parse(storedParams));
      }
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault()
    
    const formFields = {
      project,
      firstName,
      lastName,
      email,
      phone,
      howYouHear,
      news,
      ...utmParams, // Include UTM parameters
    }

    fetch("https://hooks.zapier.com/hooks/catch/3298056/2jjv1zj/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({
        "form-name": 'register-your-interest',
        ...formFields,
      }),
    })
      .then((res) => setResult(true))
      .catch((error) => console.log(error))
  }
  const props = {
    name: 'register-your-interest',
    onSubmit: handleSubmit,
  }

  if (result) return (
    <section className={`contact-form project-form ${extraClass}`}>
      <div className="contact-form__inner">
        <h2>Register your interest</h2>
        <p style={{margin: `0 auto`, maxWidth: `300px`}}>Thanks for your submission. A member of the team will be in touch soon.</p>
      </div>
    </section>
  )

  return (
    <section className={`contact-form project-form ${extraClass}`}>
      <div className="contact-form__inner">
        <h2>Register your interest</h2>

        <p>We are here to help you with your property search, and find the best home for you. </p>

        <form {...props}>
          <input type="hidden" value={utmParams.utm_source} name="utm_source" />
          <input type="hidden" value={utmParams.utm_medium} name="utm_medium" />
          <input type="hidden" value={utmParams.utm_campaign} name="utm_campaign" />
          <input type="hidden" value={utmParams.utm_term} name="utm_term" />
          <input type="hidden" value={utmParams.utm_content} name="utm_content" />
          <div className="contact-form__textarea">
            <input
              style={{borderRadius: '0', border: '1px solid #13294B'}}
              name="project"
              type="text"
              placeholder="Project Name"
              required={true}
              value={title}
              onChange={(e) => setProject(e.target.value)}
            />
          </div>

          <div className="contact-form__input">
          <input
              type="text"
              style={{borderRadius: '0', border: '1px solid #13294B'}}
              name="firstName"
              placeholder="First Name*"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              required
            />

            <input
              type="text"
              style={{borderRadius: '0', border: '1px solid #13294B'}}
              name="lastName"
              placeholder="Last Name*"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              required
            />

            <input
              style={{borderRadius: '0', border: '1px solid #13294B'}}
              name="email"
              placeholder="Contact Email*"
              value={email}
              type="email"
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <input
              type="text"
              style={{borderRadius: '0', border: '1px solid #13294B'}}
              name="phone"
              placeholder="Contact Number"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>

          <div className="contact-form__textarea">

            <select
              style={{backgroundImage: `url(${Arrow})`}}
              name="howYouHear"
              placeholder="How did you hear about us?"
              onChange={(e) => setHowYouHear(e.target.value)}
            >
              <option value="">How did you hear about us?</option>
              <option value="Advertising">Advertising</option>
              <option value="TV">TV</option>
            </select>
          </div>

          <div className="contact-form__checkbox">
            <label className={`checkbox`}>
              <input
                type="checkbox"
                name='news'
                onChange={(e) => setNews(e.target.value)}
                style={{borderRadius: '0', border: '1px solid #13294B'}}
              />
              <span>Yes, I’d like to receive news from Kervale (No spam — only occasional updates from us)</span>
            </label>

            <button className="btn btn-blue" type="submit">SUBMIT</button>
          </div>
        </form>
      </div>
    </section>
  );
};

RegisterYourInterest.defaultProps = {
  title: ``,
  content: ``,
};

export default RegisterYourInterest;